import React, { useState } from 'react';
import { IMAGE } from '../../config/constants';

interface ImageWithLoadingProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  mediaType?: string;
  fallbackText?: string;
  pdf?: boolean; // Optional prop to indicate if the image is a PDF
}

const ImageWithLoading: React.FC<ImageWithLoadingProps> = ({
                                                             src,
                                                             alt,
                                                             className,
                                                             style,
                                                             mediaType = IMAGE,
                                                             fallbackText = 'Failed to load image',
                                                             pdf = false // Default to false if not provided
                                                           }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
    setImageError(true);
  };

  return (
    <div
      className={`image-container ${isLoading && 'h-100px w-100px bg-white'}`}
      style={{ position: 'relative' }}
    >
      {/* Show the spinner while loading */}
      {isLoading && (
        <div
          className="w-50px px-2 py-1 position-absolute top-50 start-50 "
          style={{
            alignItems: 'center',
            zIndex: 10,
            transform: 'translate(-50%, -50%)'
          }}
        >
          <div
            style={{
              aspectRatio: 1,
              alignItems: 'center',
              zIndex: 10
            }}
            className="d-flex justify-content-center align-item-center rounded w-100 h-100"
          >
            <span
              className="spinner-border spinner-border-sm text-muted w-100 h-100"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        </div>
      )}

      {/* Show the image once it's loaded */}
      {!imageError && (
        <img
          style={style}
          src={src}
          alt={alt}
          draggable={false}
          className={`${className} ${isLoading ? 'd-none' : ''}`} // Hide the image while loading
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
      )}

      {/* If the image fails to load, display a fallback or an error message */}
      {imageError && (
        mediaType !== 'doc' ? (
          <div
            className={
              'm-1 h-100px w-100px d-flex flex-column border justify-content-around align-items-center p-5 bg-white'
            }
          >
            {!pdf ? (
              <>
                <i
                  style={{ fontSize: '50px', height: '50px' }}
                  className="fa-duotone fa-solid fa-file text-primary"
                ></i>
                <p style={{ fontSize: '10px' }} className="text-center">
                  {fallbackText}
                </p>
              </>
            ) : (
                <i
                style={{ fontSize: '70px', height: '70px' }}
                className="fa-duotone fa-file-pdf text-danger"
              ></i>
            )}
          </div>
        ) : (
          <div
            className={
              'm-1 h-100px w-100px d-flex flex-column border justify-content-center align-items-center p-5 bg-white'
            }
          >
            <i
              style={{ fontSize: '70px', height: '70px' }}
              className="fa-duotone fa-file-pdf text-danger"
            ></i>
          </div>
        )
      )}
    </div>
  );
};

export default ImageWithLoading;

